/**
 * Copy for a failed "fill this step with AI". Every failure is explicit and
 * ends in the same place — an error and, when a retry can help, Retry. There is
 * deliberately no path here that hands back template text as if the AI wrote it.
 */
import { codeOf, detailsOf } from './sendLabels';

export const PRIOR_STEPS_EMPTY = 'PRIOR_STEPS_EMPTY';

/** Raised before any request when an earlier step has no text for the AI to follow on from. */
export class PriorStepsEmptyError extends Error {
  readonly code = PRIOR_STEPS_EMPTY;
  constructor(readonly emptyStepNo: number) {
    super(`Step ${emptyStepNo - 1} is empty`);
  }
}

export interface FillErrorView {
  message: string;
  retryable: boolean;
}

const GENERIC = "The AI couldn't write this step.";

export function describeFillError(error: unknown): FillErrorView {
  if (error instanceof PriorStepsEmptyError) {
    return { message: `Write step ${error.emptyStepNo - 1} first, so the AI can follow on from it.`, retryable: false };
  }
  const code = codeOf(error);
  const details = detailsOf(error);
  const retryable = details?.retryable !== false;
  if (code === 'AI_NOT_CONFIGURED') return { message: "AI writing isn't set up yet.", retryable: false };
  if (code === 'TOO_MANY_REQUESTS') return { message: 'Too many AI requests. Wait a moment, then try again.', retryable: true };
  const reason = typeof details?.reason === 'string' ? details.reason : '';
  if (reason === 'agent_busy') return { message: 'The AI is busy right now.', retryable };
  if (reason === 'agent_timeout') return { message: 'The AI took too long to answer.', retryable };
  return { message: GENERIC, retryable };
}
